import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  DispatchListDetailsRes,
  getExtraDetails,
  getWorkspaceId,
  useAppSelector,
  useLazyGetDispatchNoteDetailsQuery,
} from '@zonofi/zono-money-store';
import { useParams } from 'react-router-dom';
import { createBlobObj, handleDownload } from '../../helper';
import { isEmpty } from 'lodash';
import { Tabs } from '../../components';

export const useDispatchNoteDetails = () => {
  const { dispatchNoteId } = useParams();
  const customerDetails = useAppSelector(getExtraDetails);
  const workspaceId = useAppSelector(getWorkspaceId);

  const [dispatchNoteDetails, setDispatchNoteDetails] =
    useState<DispatchListDetailsRes>();
  const [refreshNonce, setRefreshNonce] = useState(0);
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const [getDispatchNoteDetailsApi, dispatchNoteDetailsRes] =
    useLazyGetDispatchNoteDetailsQuery();

  useEffect(() => {
    if (dispatchNoteId) {
      getDispatchNoteDetailsApi({
        workspaceId,
        dispatchId: dispatchNoteId,
      });
    }
  }, [dispatchNoteId, refreshNonce]);

  useEffect(() => {
    if (dispatchNoteDetailsRes.isSuccess && dispatchNoteDetailsRes.data) {
      setDispatchNoteDetails(dispatchNoteDetailsRes.data);
    }
  }, [dispatchNoteDetailsRes]);

  const handleDownloadDispatchDetails = useCallback(async () => {
    const url = (
      dispatchNoteDetails?.docs as unknown as { url?: string }[]
    )?.[0]?.url;

    if (url) {
      const blobObj = await createBlobObj(url);
      const fileType = blobObj?.type;
      const fileName = `${customerDetails?.customerName ?? ''}_dispatch_details.${fileType?.split('/')[1]}`;
      if (blobObj) {
        handleDownload(blobObj, fileName);
      }
    }
  }, [customerDetails, dispatchNoteDetails?.docs]);

  const refresh = () => {
    setRefreshNonce((prev) => prev + 1);
  };

  const tabs: Tabs[] = useMemo(
    () => [
      {
        title: 'Details',
      },
      {
        title: 'Documents',
      },
    ],
    []
  );

  return {
    dispatchNoteDetails,
    isLoading:
      dispatchNoteDetailsRes.isFetching || dispatchNoteDetailsRes.isLoading,
    error: dispatchNoteDetailsRes.error,
    handleDownloadDispatchDetails,
    hideDownload: isEmpty(dispatchNoteDetails?.docs?.[0]?.url),
    refresh,
    tabs,
    selectedTab,
    setSelectedTab,
  };
};
